export enum StateEnum {
  Active = "ACTIVO",
  Inactive  = "INACTIVO",
  Finished = "TERMINADO",
}